__turbopack_context__.v({
  "HorizontalSquiggly": "_5LFmlG_HorizontalSquiggly",
  "White": "_5LFmlG_White",
});
